module.exports = "https://cwa.roocdn.com/_next/static/bag-deliveroo.d5320b4d.svg";